/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.organizationModule')
  .controller('OrganizationController', [
    'featureSetInfo',
    'topOrganization',
    '$interval',
    '$q',
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$translate',
    'AeroDialogService',
    'Restangular',
    'BulbAssetLibraryUploadService',
    'BulbAuthService',
    'BulbBusyService',
    'BulbErrorService',
    'BulbModalService',
    'AUTH',
    '_',
    OrganizationController,
  ]);

function OrganizationController(
  featureSetInfo,
  topOrganization,
  $interval,
  $q,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $translate,
  AeroDialogService,
  Restangular,
  BulbAssetLibraryUploadService,
  BulbAuthService,
  BulbBusyService,
  BulbErrorService,
  BulbModalService,
  AUTH,
  _,
) {
  const that = this;

  this.currentOrg = topOrganization;
  this.currentUser = BulbAuthService.currentUser;
  this.isUserBulbAdmin = BulbAuthService.currentUser.hasRole(AUTH.ROLES.ADMIN);
  this.isUserBulbOrganizationAdmin = BulbAuthService.currentUser.hasRole(AUTH.ROLES.ORGANIZATION_ADMIN);
  this.defaultOrgRestrictions = _.cloneDeep(featureSetInfo.PLUS.restrictions);

  // FUTURE : update the featureSetInfo so the default is 'false' for this
  this.defaultOrgRestrictions.publishing.publicPublishing = false;
  this.certFileName = null;
  this.settingsHasBeenClicked = false;

  this.hasGrades = false;

  // Sets the value to true when the form field is changed.
  this.isAnyFieldUpdated = false;

  this.connectionOptions = ['password_connection', 'google_connection', 'azure_ad_connection', 'clever_connection'];
  this.importType = ['full_import', 'delta_import'];

  this.LTIProviders = [];
  this.selectedLTIProvider = null;

  this.URLRegex = /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

  // The name correlates to the drop-down translated value shown on the dashboard. The "value" correlates to the
  // integer value that corresponds with the name in minute form.

  // Within this list we have the six minute timeout to be used for dev testing. Since this isn't the most helpful
  // option for actual production use, it should not be displayed on non-test environments.
  this.sessionTimeoutOptions = [
    { display: 'session_timeout_disabled', value: -1 },
    { display: 'session_timeout_half_hour', value: 30 },
    { display: 'session_timeout_hour', value: 60 },
    { display: 'session_timeout_day', value: 1440 },
    { display: 'session_timeout_week', value: 10080 },
  ];

  if (process.env.DEVTOOLS_ENABLED) {
    this.sessionTimeoutOptions.push({ display: 'session_timeout_six_minutes', value: 6 });
  }

  this.organizations = [];

  // This is to handle the accordion open/close.
  this.accordion = {};

  // Register function to track route change for this page.
  // It Will show confirmation pop up which will notify user about losing un-saved changes before navigating from
  // screen.
  // If user selects "OK" - then navigate to selected page without saving changes made by user.
  // If user selects "Cancel" - stay on the same page.
  $scope.onRouteChangeOff = $scope.$on('$stateChangeStart', routeChange);

  /**
   * This function will be registered with stateChangeEvent.
   * If form has an updated value and isn't saved. Will show confirmation modal.
   * @param event - event triggered on click.
   * @param toState - to state object.
   * @param toParams - param required by to state page.
   * @param fromState - current page state object.
   */
  function routeChange(event, toState, toParams, fromState) {
    // Navigate to newUrl if the form isn't dirty and url contains check url.
    if (!(that.isAnyFieldUpdated && fromState.url.indexOf('organization/~i') > -1)) {
      return;
    }

    const modalOptions = {
      titleCode: 'organization_integration_unsaved_changes_modal_title',
      bodyCode: 'organization_integration_unsaved_changes_modal_body',
      okButtonCode: 'organization_integration_unsaved_changes_modal_continue_button',
    };

    BulbModalService.show(modalOptions).then(() => {
      $scope.onRouteChangeOff();
      $state.go(toState, toParams, { location: false });
    }, () => {
      $rootScope.changingState = false;
      delete $rootScope.pendingUrl;
    });

    event.preventDefault();
  }

  // To store the updated organization.
  // This is required to check for the updated integrations.
  // And we update this field when the update button is clicked for the integrations.
  this.storedOrganization = Restangular.copy(topOrganization);

  // This is to handle the accordion open/close.
  this.accordion = {};

  this.current = {
    topOrg: topOrganization,
    dashMetrics: topOrganization.metrics,
    id: topOrganization.id,
    item: '', // the currently selected item for sorting in the table below, such as "# of accounts".
  };

  this.orgIdCopyMessage = `Organization ID: ${this.current.id}`;

  this.canDoGradePromotion = !('clever' in this.current.topOrg.integrationsMap)
    && !('classLink' in this.current.topOrg.integrationsMap);

  // This will be the polling promise that will resolve for the topOrgs' archiveStatus.
  // This is set within the initial enabling of the archive feature with the $interval service.
  let archiveStatusCheck = null;

  this.changeOrgSessionTimeout = function (sessionTimeoutValue) {
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', that.current.topOrg.id).patch({ sessionTimeout: sessionTimeoutValue }),
    );
  };

  this.generateInviteToken = function (organization) {
    BulbBusyService.showBusyDuring(
      Restangular.all(`token/group/${organization.id}`).post().then((inviteToken) => {
        organization.inviteToken = inviteToken.token;
      }),
    );
  };

  this.deleteInviteToken = function (organization) {
    const modalOptions = {
      titleCode: 'organization_bulb_school_direct_toggle_warning_title',
      bodyCode: 'organization_access_token_toggle_warning',
      showOkButton: true,
      showCancelButton: true,
    };

    BulbModalService.show(modalOptions).then(() => {
      BulbBusyService.showBusyDuring(
        Restangular.all(`token/group/${organization.id}`).remove()
          .then(() => {
            that.accordion.isInviteTokenSet = false;
            delete organization.inviteToken;
          }),
      );
    });
  };

  /**
   * Toggle the org level resume feature.
   */
  this.toggleOrgResumeFeature = function () {
    that.current.topOrg.resumeEnabled = !that.current.topOrg.resumeEnabled;
    const organizationDTO = {
      resumeEnabled: that.current.topOrg.resumeEnabled,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', that.current.topOrg.id).patch(organizationDTO).then(() => {
        $rootScope.$broadcast('$orgRestrictionsChanged');
      }),
    );
  };

  /**
   * Toggle the group display name feature.
   */
  this.toggleUseGroupName = function () {
    that.current.topOrg.useGroupName = !that.current.topOrg.useGroupName;
    const organizationDTO = {
      useGroupName: that.current.topOrg.useGroupName,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', that.current.topOrg.id).patch(organizationDTO).then(() => {
      }),
    );
  };

  /**
   * Generate or delete invite token on toggle on/off.
   * @param organization
   */
  this.toggleInviteToken = function (organization) {
    if (!that.accordion.isInviteTokenSet) {
      that.accordion.isInviteTokenSet = true;
      that.deleteInviteToken(organization);
    } else if (that.accordion.isInviteTokenSet && !organization.inviteToken) {
      that.generateInviteToken(organization);
    }
  };

  // Once the controller gets loaded, we first check to see if we have a polling function for the archive status.
  // If we do, let it be and continue to poll, if we don't, initialize the polling.
  if (this.current.topOrg.archiveStatus.status === 'PROCESSING') {
    if (!archiveStatusCheck) {
      archiveStatusCheck = $interval(checkArchiveStatus, 3000);
    }
  }

  // Needed so that we don't indefinitely poll for the archive status on an org.
  $scope.$on('$destroy', () => {
    // Destroy the interval that polls for the archive status
    if (archiveStatusCheck) {
      $interval.cancel(archiveStatusCheck);
    }
  });

  // Ping the server for the status of the org wide archive feature
  function checkArchiveStatus() {
    Restangular.one('organizations', that.current.topOrg.id).customGET('archiveStatus').then((statusResponse) => {
      that.current.topOrg.archiveStatus.secondsRemaining = statusResponse.secondsRemaining;
      that.current.topOrg.archiveStatus.status = statusResponse.status;
      if (statusResponse.status === 'ENABLED') {
        if (archiveStatusCheck) {
          $interval.cancel(archiveStatusCheck);
          archiveStatusCheck = null;
        }
      }
    });
  }

  /**
   * Function that enable/disable the teacher visibility setting of the organization.
   */
  this.toggleTeacherVisibility = function () {
    const organizationDTO = {
      teacherVisibilityEnabled: !that.current.topOrg.teacherVisibilityEnabled,
    };

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', that.current.topOrg.id).patch(organizationDTO)
        .then((updatedOrganization) => {
          that.current.topOrg.teacherVisibilityEnabled = updatedOrganization.teacherVisibilityEnabled;
        }),
    );
  };

  /**
   * Function that enable/disable the web search setting of the organization.
   */
  this.toggleWebSearches = function () {
    const organizationDTO = {
      webSearchIndexingEnabled: !that.current.topOrg.webSearchIndexingEnabled,
    };

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', that.current.topOrg.id).patch(organizationDTO)
        .then((updatedOrganization) => {
          that.current.topOrg.webSearchIndexingEnabled = updatedOrganization.webSearchIndexingEnabled;
        }),
    );
  };

  /**
   * Function to open the grade promotion confirm modal and send the grade promotion request.
   */
  this.gradePromotion = () => {
    BulbModalService.show({
      titleCode: 'organization_grade_promotion_modal_title',
      bodyCode: 'organization_grade_promotion_modal_description',
      okButtonCode: 'organization_grade_promotion_modal_button',
      fontAwesomeCode: 'fas fa-exclamation-triangle',
      windowClass: 'bulb-aero-modal-body bulb-aero-modal-buttons',
      showCancelButton: true,
    }).then(() => {
      Restangular.one('organizations', that.current.topOrg.id).one('gradeLevels').patch()
        .then((updatedOrganization) => {
          that.current.topOrg.lastGradeUpdate = updatedOrganization.lastGradeUpdate;
        });
    });
  };

  /**
   * Function to open copy template dialog.
   */
  this.copyTemplate = () => {
    const dialog = AeroDialogService.showCopyTemplateDialog(this.current.id);

    const subscription = dialog.onClose.subscribe(() => {
      AeroDialogService.removeDialog();
      subscription.unsubscribe();
    });
  };

  /**
   * Function that enables the archiving feature org wide. Global toggle, once enabled it cannot be disabled.
   */
  this.enableArchiving = function () {
    const modalOptions = {
      fontAwesomeCode: 'fas fa-inbox',
      titleCode: 'organization_archive_collection_header',
      bodyCode: 'organization_archive_collection_body_instructions',
      okButtonCode: 'organization_archive_enable_button',
      cancelButtonCode: 'organization_archive_cancel_button',
      showCancelButton: true,
      windowClass: 'updated-modal-design bulb-admin-dashboard-archive-modal', // Name is going to change from the refactor that I did.
    };

    // Show the enable Archive Collection modal
    BulbModalService.show(modalOptions).then(() => {
      BulbBusyService.showBusyDuring(
        Restangular.one('organizations', that.current.topOrg.id).patch({ enableArchiving: true }).then((updatedOrganiztion) => {
          that.current.topOrg.archiveStatus.status = updatedOrganiztion.archiveStatus.status;
          // Do initial, immediate archiving status check
          checkArchiveStatus();
          // Poll for the status every 3 seconds
          archiveStatusCheck = $interval(checkArchiveStatus, 3000);
        }),
      );
    });
  };

  /**
   * Enable isInviteTokenSet Accordion for the organization.
   */
  this.enableActiveAccordion = function (organization) {
    that.accordion = {};
    if (organization.inviteToken) {
      that.accordion.isInviteTokenSet = true;
    }
  };

  /**
   * Check for Unsaved Changes.
   * and if its true then prompt for Unsaved Changes.
   * @param tab
   */
  this.checkAndPromptUnsavedChanges = function (tab) {
    // If we're going to the admin settings page for the FIRST time, don't show the modal no matter what on the
    // first load of the tab being clicked. Only show it when navigating away from this tab or refreshing.
    if (tab === 'ADMIN' && !that.settingsHasBeenClicked) {
      that.settingsHasBeenClicked = true;
      that.setupSettingsPage(that.current.topOrg);
      return;
    }

    // Check for form changes.
    if (that.isAnyFieldUpdated) {
      // By default be on the ADMIN tab.
      that.activeTab = {};
      that.activeTab.ADMIN = true;

      // Prompt for Unsaved Changes.
      that.onTabChangePromptUnsavedChanges().then(() => {
        that.isAnyFieldUpdated = false;
        that.activeTab = {};
        that.activeTab[tab] = true;
        if (tab === 'ADMIN') {
          that.setupSettingsPage(that.current.topOrg);
        }
      });
    }
  };

  /**
   * Enable inviteToken & integrations Accordion, which are active for the organization.
   */
  this.enableActiveAccordion = function (organization) {
    that.accordion = {};
    if (organization.inviteToken) {
      that.accordion.isInviteTokenSet = true;
    }
    Object.keys(organization.integrationsMap).forEach((configType) => {
      that.accordion[configType] = true;
    });
  };

  let grabbedAccordions = {};
  this.setupSettingsPage = function (organization) {
    $timeout(() => {
      grabbedAccordions = {
        restrictions: { element: $('.publishing-sharing-group:first-child > a') },
      };

      if (that.storedOrganization.integrationsMap.lTIAdvantage) {
        loadProviders().then(() => {
          if (that.storedOrganization.integrationsMap.lTIAdvantage) {
            that.selectedLTIProvider = that.LTIProviders.find(
              (provider) => provider.value === that.storedOrganization.integrationsMap.lTIAdvantage.providerId,
            ).value;
          }
        });
      }

      BulbBusyService.showBusyDuring(Restangular.one('groups', organization.id)
        .customGET(null, { metrics: false })
        .then((organization) => {
          // Set the dummy password
          that.setDummyPassword(organization);
          that.current.topOrg = organization;
          Restangular.one(`token/group/${organization.id}`).get()
            .then((orgInviteToken) => {
              if (orgInviteToken) {
                that.current.topOrg.inviteToken = orgInviteToken.token;
              }
            }).finally(() => {
              // To enable Accordion.
              that.enableActiveAccordion(that.current.topOrg);
            });
        }).then(() => {
          that.unbindAccordions(organization);
          if (that.current.topOrg.restrictions === null) {
            that.current.topOrg.restrictions = that.defaultOrgRestrictions;
          }

          // We broadcast here that we've successfully loaded an organization, so that the directive
          // for the restrictions can properly run the functions to set up the checkboxes, see:
          // organization-restrictions-controller.js.
          $rootScope.$broadcast('$orgRestrictionsLoaded');
        }));
    });
  };

  /**
   * Set the dummy password for fTP, oneRoster or classLink
   * @param organization
   */
  this.setDummyPassword = function (organization) {
    // Creating a random password string.
    $scope.password = Math.random().toString(36).slice(2);
    Object.keys(organization.integrationsMap).forEach((configType) => {
      if (configType === 'fTP' || configType === 'oneRoster' || configType === 'classLink') {
        organization.integrationsMap[configType].password = $scope.password;
      }
    });
  };

  // This is required because Angular/Foundation's version of Accordion that we are using does not support disabling
  // the click on the header at any point, so this is our way of unbinding it, only if the values are already set
  this.unbindAccordions = function (organization) {
    // These are the accordions that need to be disabled always, regardless of settings.
    grabbedAccordions.restrictions.element.off('click');

    grabbedAccordions.restrictions.element.off('click');
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableLTI = function (organization) {
    if (that.accordion.lTILaunch && !organization.integrationsMap.lTILaunch) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.lTILaunch = {
        key: '',
        type: 'LTILaunchConfiguration',
        importAccountsOnly: false,
      };
    } else if (!that.accordion.lTILaunch) {
      if (that.storedOrganization.integrationsMap.lTILaunch) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.lTILaunch = true;
        that.confirmModal(organization, 'lTILaunch', 'LTILaunchConfiguration');
      } else {
        delete organization.integrationsMap.lTILaunch;
      }
    }
  };

  /**
   * Load the list of LTI Providers and set the selected one if it exists.
   */
  const loadProviders = function loadProviders() {
    return Restangular.one('/lti/providers/').get().then((providers) => {
      that.LTIProviders = providers.map((provider) => (
        {
          display: provider.name,
          value: provider.id,
        }
      ));
    });
  };

  /**
   * Enables the LTI Advantage accordion.
   *
   * @param organization to enable it on.
   */
  this.enableLTIAdvantage = function enableLTIAdvantage(organization) {
    if (that.accordion.lTIAdvantage && !organization.integrationsMap.lTIAdvantage) {
      loadProviders();
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.lTIAdvantage = {
        type: 'ltiAdvantageConfig',
        providerId: '',
        deploymentId: '',
        iframeWhitelistURL: '',
      };
    } else if (!that.accordion.lTIAdvantage) {
      if (that.storedOrganization.integrationsMap.lTIAdvantage) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.lTIAdvantage = true;
        that.confirmModal(organization, 'lTIAdvantage', 'ltiAdvantageConfig');
      } else {
        that.selectedLTIProvider = { value: null, display: null };
        delete organization.integrationsMap.lTIAdvantage;
      }
    }
  };

  /**
   * Sets the LTI Provider on the organization from the dropdown.
   *
   * @param event to find the Provider id from.
   */
  this.handleSettingProviderId = function handleSettingProviderId(event) {
    that.current.topOrg.integrationsMap.lTIAdvantage.providerId = event.selectedOption;
    that.ltiAdvantageConfigForm.$pristine = false;
  };

  /**
   * Updates the LTI Advantage Configuration
   * @param organization to update the config on.
   */
  this.updateLTIAdvantageConfig = function updateLTIAdvantageConfig(organization) {
    const organizationDTO = {
      ltiAdvantageConfig: organization.integrationsMap.lTIAdvantage,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Edits the LTI Configuration
   * @param organization
   */
  this.editLtiKey = function (organization) {
    const organizationDTO = {
      ltiKey: organization.integrationsMap.lTILaunch.key,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableMo365Integration = function (organization) {
    if (that.accordion.mo365 && !organization.integrationsMap.mo365) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.mo365 = {
        type: 'mo365Config',
        importAccountsOnly: false,
      };
    } else if (!that.accordion.mo365) {
      if (that.storedOrganization.integrationsMap.mo365) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.mo365 = true;
        that.confirmModal(organization, 'mo365', 'mo365Config');
      } else {
        delete organization.integrationsMap.mo365;
      }
    }
  };

  /**
   * Updates the Mo365 Configuration
   * @param organization
   */
  this.updateMo365Config = function (organization) {
    const organizationDTO = {
      mo365Config: organization.integrationsMap.mo365,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableFTPIntegration = function (organization) {
    if (that.accordion.fTP && !organization.integrationsMap.fTP) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.fTP = {
        type: 'ftpConfig',
        port: 22,
        folder: '/',
        importType: this.importType[0],
        importAccountsOnly: false,
        accountPositionConnectionMap: {
          STUDENT: this.connectionOptions[0],
          EDUCATOR: this.connectionOptions[0],
          ADMINISTRATOR: this.connectionOptions[0],
          OTHER: this.connectionOptions[0],
        },
        protocol: 'SFTP',
      };
    } else if (!that.accordion.fTP) {
      if (that.storedOrganization.integrationsMap.fTP) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.fTP = true;
        that.confirmModal(organization, 'fTP', 'ftpConfig');
      } else {
        delete organization.integrationsMap.fTP;
      }
    }
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableSchoologyIntegration = function enableSchoologyIntegration(organization) {
    if (that.accordion.schoology && !organization.integrationsMap.schoology) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.schoology = {
        type: 'schoologyConfig',
        importAccountsOnly: false,
      };
    } else if (!that.accordion.schoology) {
      if (that.storedOrganization.integrationsMap.schoology) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.schoology = true;
        that.confirmModal(organization, 'schoology', 'schoologyConfig');
      } else {
        delete organization.integrationsMap.schoology;
      }
    }
  };

  /**
   * Edits the Schoology Configuration
   * @param organization
   */
  this.updateSchoologyIntegration = function updateSchoologyIntegration(organization) {
    const organizationDTO = {
      schoologyConfig: organization.integrationsMap.schoology,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableCanvasIntegration = function enableCanvasIntegration(organization) {
    if (that.accordion.canvas && !organization.integrationsMap.canvas) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.canvas = {
        type: 'canvasConfig',
        importAccountsOnly: false,
      };
    } else if (!that.accordion.canvas) {
      if (that.storedOrganization.integrationsMap.canvas) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.canvas = true;
        that.confirmModal(organization, 'canvas', 'canvasConfig');
      } else {
        delete organization.integrationsMap.canvas;
      }
    }
  };

  /**
   * Edits the Canvas Configuration
   * @param organization
   */
  this.updateCanvasIntegration = function updateCanvasIntegration(organization) {
    const organizationDTO = {
      canvasConfig: organization.integrationsMap.canvas,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
      }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableWondeIntegration = function enableWondeIntegration(organization) {
    if (that.accordion.wonde && !organization.integrationsMap.wonde) {
      organization.integrationsMap.wonde = {
        type: 'wondeConfig',
      };
    } else if (!that.accordion.wonde) {
      if (that.storedOrganization.integrationsMap.wonde) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.wonde = true;
        that.confirmModal(organization, 'wonde', 'wondeConfig');
      } else {
        delete organization.integrationsMap.wonde;
      }
    }
  };

  /**
   * Edits the Wonde Configuration
   * @param organization
   */
  this.updateWondeIntegration = function updateWondeIntegration(organization) {
    const organizationDTO = {
      wondeConfig: organization.integrationsMap.wonde,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Handle setting the importType from our angular aero dropdown component.
   * @param event - value selected event.
   */
  this.handleSettingFtpImportType = function (event) {
    that.current.topOrg.integrationsMap.fTP.importType = event.selectedOption;
    that.ftpConfigForm.$pristine = false;
  };

  /**
   * Handle setting the connection types from our angular aero dropdown component.
   * @param event - value selected event.
   * @param type - type of value selected from dropdown.
   */
  this.handleSettingFtpConnectionOptions = function (event, type) {
    that.current.topOrg.integrationsMap.fTP.accountPositionConnectionMap[type] = event.selectedOption;
    that.ftpConfigForm.$pristine = false;
  };

  /**
   * Updates the fTP Configuration
   * @param organization
   */
  this.updateFTPConfig = function (organization) {
    // Remove the dummy password
    that.removeDummyPassword(organization, 'fTP');
    const organizationDTO = {
      ftpConfig: organization.integrationsMap.fTP,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          // Set the dummy password
          that.setDummyPassword(editedOrganization);
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableOneRosterIntegration = function (organization) {
    if (that.accordion.oneRoster && !organization.integrationsMap.oneRoster) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.oneRoster = {
        type: 'oneRosterConfig',
        port: 22,
        folder: '/',
        importType: this.importType[0],
        importAccountsOnly: false,
        accountPositionConnectionMap: {
          STUDENT: this.connectionOptions[0],
          EDUCATOR: this.connectionOptions[0],
          ADMINISTRATOR: this.connectionOptions[0],
          OTHER: this.connectionOptions[0],
        },
        or_Version: '1.1', // jshint ignore:line
        protocol: 'SFTP',
      };
    } else if (!that.accordion.oneRoster) {
      if (that.storedOrganization.integrationsMap.oneRoster) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.oneRoster = true;
        that.confirmModal(organization, 'oneRoster', 'oneRosterConfig');
      } else {
        delete organization.integrationsMap.oneRoster;
      }
    }
  };

  /**
   *  Updates the oneRoster Configuration
   * @param organization
   */
  this.updateOneRosterConfig = function (organization) {
    // Remove the dummy password
    that.removeDummyPassword(organization, 'oneRoster');
    const organizationDTO = {
      oneRosterConfig: organization.integrationsMap.oneRoster,
    };

    // Handle the switching of importType for District.
    Object.keys(organizationDTO.oneRosterConfig).forEach((oneRosterConfigKey) => {
      if (organizationDTO.oneRosterConfig.or_ImportType === 'oneroster_csv') { // jshint ignore:line
        // If importType is CSV then reset te fields required for import Type as API.
        if ((oneRosterConfigKey === 'clientId') || (oneRosterConfigKey === 'clientSecret')
          || (oneRosterConfigKey === 'endpointUrl')) {
          organizationDTO.oneRosterConfig[oneRosterConfigKey] = null;
        }
      } else if (organizationDTO.oneRosterConfig.or_ImportType === 'oneroster_api') { // jshint ignore:line
        // If importType is API then reset te fields required for import Type as CSV.
        if ((oneRosterConfigKey === 'folder') || (oneRosterConfigKey === 'host')
          || (oneRosterConfigKey === 'password') || (oneRosterConfigKey === 'protocol')
          || (oneRosterConfigKey === 'username')) {
          organizationDTO.oneRosterConfig[oneRosterConfigKey] = null;
        }
      }
    });

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          // Set the dummy password
          that.setDummyPassword(editedOrganization);
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Handle setting the oneRoster importType from our angular aero dropdown component.
   * @param event
   */
  this.handleSettingOneRosterImportType = function (event) {
    that.current.topOrg.integrationsMap.oneRoster.importType = event.selectedOption;
    that.oneRosterForm.$pristine = false;
  };

  /**
   * Handle setting the connection types from our angular aero dropdown component.
   * @param type - type of value selected from dropdown.
   * @param event
   */
  this.handleSettingOneRosterConnectionOptions = function (event, type) {
    that.current.topOrg.integrationsMap.oneRoster.accountPositionConnectionMap[type] = event.selectedOption;
    that.oneRosterForm.$pristine = false;
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableClassLinkIntegration = function (organization) {
    if (that.accordion.classLink && !organization.integrationsMap.classLink) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.classLink = {
        type: 'classLinkConfig',
        port: 22,
        folder: '/',
        importType: this.importType[0],
        importAccountsOnly: false,
        or_Version: '1.1', // jshint ignore:line
        protocol: 'SFTP',
      };
    } else if (!that.accordion.classLink) {
      if (that.storedOrganization.integrationsMap.classLink) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.classLink = true;
        that.confirmModal(organization, 'classLink', 'classLinkConfig');
      } else {
        delete organization.integrationsMap.classLink;
      }
    }
  };

  /**
   * Updates the ClassLink Configuration
   * by patch method API
   * @param organization
   */
  this.updateClassLinkConfig = function (organization) {
    // Remove the dummy password
    that.removeDummyPassword(organization, 'classLink');
    const organizationDTO = {
      classLinkConfig: organization.integrationsMap.classLink,
    };

    // Handle the switching of importType for District.
    Object.keys(organizationDTO.classLinkConfig).forEach((classLinkConfigKey) => {
      if (organizationDTO.classLinkConfig.or_ImportType === 'classLink_csv') { // jshint ignore:line
        // If importType is CSV then reset te fields required for import Type as API.
        if ((classLinkConfigKey === 'clientId') || (classLinkConfigKey === 'clientSecret')
          || (classLinkConfigKey === 'endpointUrl')) {
          organizationDTO.classLinkConfig[classLinkConfigKey] = null;
        }
      } else if (organizationDTO.classLinkConfig.or_ImportType === 'classLink_api') { // jshint ignore:line
        // If importType is API then reset te fields required for import Type as CSV.
        if ((classLinkConfigKey === 'folder') || (classLinkConfigKey === 'host')
          || (classLinkConfigKey === 'password') || (classLinkConfigKey === 'protocol')
          || (classLinkConfigKey === 'username')) {
          organizationDTO.classLinkConfig[classLinkConfigKey] = null;
        }
      }
    });

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          // Set the dummy password
          that.setDummyPassword(editedOrganization);
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Handle setting the classLink importType from our angular aero dropdown component.
   * @param event
   */
  this.handleSettingClasslinkImportType = function (event) {
    that.current.topOrg.integrationsMap.classLink.importType = event.selectedOption;
    that.classLinkConfigForm.$pristine = false;
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableCleverIntegration = function (organization) {
    if (that.accordion.clever && !organization.integrationsMap.clever) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.clever = {
        type: 'cleverConfig',
        importAccountsOnly: false,
      };
    } else if (!that.accordion.clever) {
      if (that.storedOrganization.integrationsMap.clever) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.clever = true;
        that.confirmModal(organization, 'clever', 'cleverConfig');
      } else {
        delete organization.integrationsMap.clever;
      }
    }
  };

  /**
   * Updates the Clever Configuration
   * by patch method API
   * @param organization
   */
  this.updateCleverConfig = function (organization) {
    const organizationDTO = {
      cleverConfig: organization.integrationsMap.clever,
    };
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the integration.
   * @param organization
   */
  this.enableGoogleIntegration = function (organization) {
    if (that.accordion.google && !organization.integrationsMap.google) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.google = {
        type: 'googleConfig',
      };
    } else if (!that.accordion.google) {
      if (that.storedOrganization.integrationsMap.google) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.google = true;
        that.confirmModal(organization, 'google', 'googleConfig');
      } else {
        delete organization.integrationsMap.google;
      }
    }
  };

  /**
   * Updates the Google Classroom Configuration
   * by patch method API
   * @param organization
   */
  this.updateGoogleConfig = function (organization) {
    const updatedOrganization = {
      googleConfig: organization.integrationsMap.google,
    };
    if (updatedOrganization.googleConfig.googleKeyType === 'google_p12') {
      updatedOrganization.googleConfig.privateKeyContent = null;
    }
    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(updatedOrganization)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  /**
   * Sets the default value to the fields on accordion open
   * and on close a confirm modal opens for off the IFrame integration.
   * @param organization
   */
  this.enableIFrameEmbedIntegration = function (organization) {
    if (that.accordion.iFrameEmbed && !organization.integrationsMap.iFrameEmbed) {
      // if its enabled then we set the default values in the field.
      organization.integrationsMap.iFrameEmbed = {
        type: 'iFrameEmbedConfig',
      };
    } else if (!that.accordion.iFrameEmbed) {
      if (that.storedOrganization.integrationsMap.iFrameEmbed) {
        // keeping the modal open till the user confirms the pop-up
        that.accordion.iFrameEmbed = true;
        that.confirmModal(organization, 'iFrameEmbed', 'iFrameEmbedConfig');
      } else {
        delete organization.integrationsMap.iFrameEmbed;
      }
    }
  };

  /**
   * Updates the IFrame Embed Configuration
   * by patch method API
   * @param organization
   */
  this.updateIFrameEmbedConfig = function (organization) {
    const updatedOrganization = {
      iframeEmbedConfig: organization.integrationsMap.iFrameEmbed,
    };

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(updatedOrganization)
        .then((editedOrganization) => {
          organization.integrationsMap = editedOrganization.integrationsMap;
          // To enable the active integrations.
          that.enableActiveAccordion(editedOrganization);
          that.storedOrganization.integrationsMap = Restangular.copy(editedOrganization.integrationsMap);
          that.isAnyFieldUpdated = false;
        }),
    );
  };

  this.toggleBulbSchoolDirect = function (organization) {
    if (that.isUserBulbAdmin) {
      if (organization.bulbSchoolDirect) {
        that.editBulbSchoolDirect(organization, false);
      } else {
        that.editBulbSchoolDirect(organization, true);
      }
    }
  };

  this.editBulbSchoolDirect = function (organization, isEnabled) {
    const modalOptions = {
      titleCode: 'organization_bulb_school_direct_toggle_warning_title',
      bodyCode: 'organization_bulb_school_direct_toggle_warning',
      showOkButton: true,
      showCancelButton: true,
    };

    BulbModalService.show(modalOptions).then(() => {
      const organizationDTO = {
        bulbSchoolDirect: isEnabled,
      };

      BulbBusyService.showBusyDuring(
        Restangular.one('organizations', organization.id).patch(organizationDTO)
          .then((editedOrganization) => {
            organization.bulbSchoolDirect = editedOrganization.bulbSchoolDirect;
          }),
      );
    });
  };

  this.sendBSDEmails = function (organization) {
    const modalOptionsAlreadySent = {
      titleCode: 'organization_bulb_school_direct_already_sent',
      bodyCode: 'organization_bulb_school_direct_already_sent_body',
      showOkButton: true,
      showCancelButton: true,
    };

    const modalOptions = {
      titleCode: 'organization_bulb_school_direct_emails',
      bodyCode: 'organization_bulb_school_direct_emails_body',
      showOkButton: true,
      showCancelButton: true,
    };

    BulbModalService.show(modalOptions).then(() => {
      const organizationDTO = {
        sentBSDEmail: true,
      };

      if (organization.sentBSDEmail) {
        BulbModalService.show(modalOptionsAlreadySent).then(() => {
          Restangular.one('organizations', organization.id).patch(organizationDTO)
            .then((editedOrganization) => {
              organization.sentBSDEmail = editedOrganization.sentBSDEmail;
            });
        });
      } else {
        Restangular.one('organizations', organization.id).patch(organizationDTO)
          .then((editedOrganization) => {
            organization.sentBSDEmail = editedOrganization.sentBSDEmail;
          });
      }
    });
  };

  this.isAdministrator = function (organization) {
    return organization.administratorIds.indexOf(`Account:${BulbAuthService.currentUser.id}`) !== -1
      || BulbAuthService.currentUser.hasRole(AUTH.ROLES.ADMIN);
  };

  this.setActiveTab = function (tab) {
    if (typeof tab !== 'undefined') {
      $rootScope.$emit('tabSelected', tab);
    }

    // Need to do it this way to be able to set the tab without clicking on it.
    this.activeTab = {};
    this.activeTab[tab] = true;
  };

  this.toggleChevron = function (schoolId) {
    $(`#chevron_for_${schoolId}`).toggleClass('rot180');
  };

  // Filter to upload file type based on googleKeyType
  const fileTypeFilter = function () {
    return that.current.topOrg.integrationsMap.google.googleKeyType === 'google_json' ? 'application/json' : '.p12';
  };

  this.uploadOptions = {
    // attached file upload options
    createAttachedFileUploadOptions(deleteOnEnd) {
      return that.createAttachedFileUploadOptions(that, deleteOnEnd);
    },
  };

  // upload attached files
  this.uploadAttachedFiles = function (handlerObj, addHandlerName) {
    const options = that.uploadOptions.createAttachedFileUploadOptions(
      true,
      handlerObj,
      addHandlerName,
      false,
    );
    BulbAssetLibraryUploadService.uploadFile(options, fileTypeFilter, false);
  };

  // attached file upload options
  this.createAttachedFileUploadOptions = function (handlerObj, deleteOnEnd) {
    let file;
    const options = angular.merge({}, {

      add(e, data) {
        if (data.abortUploading) {
          return;
        }

        file = data.files[0];

        data.process().done(() => {
          const reader = new FileReader();
          if (file.name.match('json')) {
            reader.readAsBinaryString(data.files[0]);
          } else {
            reader.readAsArrayBuffer(data.files[0]);
          }
          reader.onload = function (event) {
            data.target = event.target;
            const { result } = data.target;
            that.certFileName = file.name;
            if (file.name.match('json')) {
              that.parsePrivateKeyJson(result);
            } else {
              const array = new Uint8Array(result);
              const buffer = [];

              array.map((value, i) => {
                buffer[i] = value;
              });
              that.current.topOrg.integrationsMap.google.p12Content = buffer;
              // assigning certFileName here just to display in the text area, it will not get updated in
              // the database
              that.current.topOrg.integrationsMap.google.privateKeyContent = that.certFileName;
            }
            $scope.$apply();
            if (deleteOnEnd) {
              $(e.target).remove();
            }
          };
        });
      },
    });
    return options;
  };

  /**
   * Reset privateKeyContent on change event of radio buttons
   */
  this.resetPrivateKey = function () {
    that.current.topOrg.integrationsMap.google.privateKeyContent = null;
  };

  /**
   * Automatically replace unwanted characters from json input in the teaxt area
   */
  $scope.$watch('organizationCtrl.current.topOrg.integrationsMap.google.privateKeyContent', (content) => {
    if (content) {
      that.parsePrivateKeyJson(content);
    }
  });

  // Check if it is a valid json
  this.isJson = function (jsonString) {
    try {
      JSON.parse(jsonString);
    } catch (e) {
      return false;
    }
    return true;
  };

  // Parse json content and remove any unwanted special characters from the content
  this.parsePrivateKeyJson = function (result) {
    let privateKey;
    if (that.isJson(result)) {
      // parsing the JSON content to get the value of the key "private_key" from the JSON content
      privateKey = JSON.parse(result).private_key; // jshint ignore:line
    } else if (result.indexOf('private_key') > -1) {
      privateKey = result.replace('"private_key":', '');
      privateKey = privateKey.replace(/[,'":*{}\n]/g, '');
    } else {
      privateKey = result;
    }
    privateKey = privateKey.replace('-----BEGIN PRIVATE KEY-----', '');
    privateKey = privateKey.replace('-----END PRIVATE KEY-----', '');
    privateKey = privateKey.replace(/\s/g, '');
    privateKey = privateKey.replace(/\\n/g, '');
    that.current.topOrg.integrationsMap.google.privateKeyContent = privateKey;
  };

  /**
   * It prompts a pop-up for confirming whether to turn off the integration.
   * @param organization
   * @param integration
   * @param integrationType
   */
  this.confirmModal = function (organization, integration, integrationType) {
    const modalOptions = {
      titleCode: 'organization_turn_off_integration_modal_title',
      bodyCode: 'organization_turn_off_integration_modal_body',
      okButtonCode: 'organization_turn_off_integration_modal_confirm_button',
    };

    BulbModalService.show(modalOptions).then(() => {
      BulbBusyService.showBusyDuring(
        Restangular.one('organizations', organization.id).one('integrationType', integrationType).remove()
          .then(() => {
            that.accordion[integration] = false;
            if (integration === 'lTIAdvantage') {
              that.selectedLTIProvider = { value: null, display: null };
            }
            delete organization.integrationsMap[integration];
            delete that.storedOrganization.integrationsMap[integration];
          }),
      );
    });
  };

  /**
   * Remove the dummy password for the given integration.
   * @param organization
   * @param integration
   */
  this.removeDummyPassword = function (organization, integration) {
    if (organization.integrationsMap[integration].password === $scope.password) {
      delete organization.integrationsMap[integration].password;
    }
  };

  /**
   * Prompt for Unsaved Changes.
   * @returns {*}
   */
  this.onTabChangePromptUnsavedChanges = function () {
    const deferred = $q.defer();
    const modalOptions = {
      titleCode: 'organization_integration_unsaved_changes_modal_title',
      bodyCode: 'organization_integration_unsaved_changes_modal_body',
      okButtonCode: 'organization_integration_unsaved_changes_modal_continue_button',
    };

    BulbModalService.show(modalOptions).then(() => {
      deferred.resolve(true);
    }, () => {
      deferred.reject(false);
    });

    return deferred.promise;
  };

  this.copyOrgIdToClipboard = function () {
    if (this.orgIdCopyMessage.endsWith('Copied!')) return;

    navigator.clipboard.writeText(this.current.id);
    this.orgIdCopyMessage = `${this.orgIdCopyMessage} Copied!`;
    setTimeout(() => {
      this.orgIdCopyMessage = this.orgIdCopyMessage.substring(0, this.orgIdCopyMessage.length - 8);
    }, 2000);
  };

  /**
   * Check and Prompt if the form changes are true on 'onbeforeunload'.
   * @returns {string}
   */
  window.onbeforeunload = function () {
    if (that.isAnyFieldUpdated) {
      return 'organization_integration_unsaved_changes_modal_body';
    }
  };
}
